import { connect } from 'react-redux';
import { updateEBookDataRoutine } from 'redux-state/ducks/player';
import NavigationMenu from './navigation-menu.component';

const mapStateToProps = ({ player }) => ({
    queue: player.queue,
    activeIndex: player.activeIndex,
});

const mapDispatchToProps = {
  updateEBookDataAction: updateEBookDataRoutine.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavigationMenu);
